import * as angular from 'angular';
export class GiftCardsImportModelService {

    constructor (private CurrencyService: any) {

    }
    checkIfDecimalIsZero = (amountToChekDecimals) => {
        const numberToReturn = amountToChekDecimals?.split(',')[1]?.split(' ')[0] === '00' ? amountToChekDecimals?.split(',')[0] : amountToChekDecimals;
        return numberToReturn;
    };
    transformInfo = (data : Types.AvailabilityGiftCards) : Types.AvailabilityGiftCards =>{
        const arrayMax : number[] = [];
        const code = data.currency.code;
        data.currency =  this.CurrencyService.getCurrencyObject(data.currency);
        data.currency.code = code;
        for(let i = 0; i <=2; i++ ) {
            let dataPoint = i == 0 ? 'groupFixedPrices' : 'fixedPrices';
            let nameForGroup = dataPoint == 'groupFixedPrices' ? '_group' : '';
            let hasDiscount = false;
            data[dataPoint]?.forEach ( (datatype, index)=>{
                datatype.name = `radio_${datatype.amount}_${index}${nameForGroup}`;
                datatype.price = this.CurrencyService.formatPrice ( data.currency, datatype.amount, false, false, true);
                if(datatype.discount){
                    datatype.discount.price = this.checkIfDecimalIsZero(this.CurrencyService.formatPrice( data.currency, datatype.discount.amount, true));
                    arrayMax.push(datatype.discount.percentage);
                    hasDiscount = true;
                }
            });
            if(hasDiscount) {
                data[dataPoint].hasDiscount = true;
            }
        }
        
        arrayMax.push(data?.customPrice?.percentage);
        data.maxPercentage = Math.max(...arrayMax);
        return data;
    };
    
}
GiftCardsImportModelService.$inject = ['CurrencyService'];
try {
    const mod = angular.module('ib-gift-cards-service-module');
    mod.service(
        'GiftCardsImportModelService',
        GiftCardsImportModelService
    );
} catch (error) {
    const mod = angular.module('ib-gift-cards-service-module', []);
    mod.service(
        'GiftCardsImportModelService',
        GiftCardsImportModelService
    );
}
